// extracted by mini-css-extract-plugin
module.exports = {"logo":"login_logo__J6-If","formDescription":"login_formDescription__2ych2","login":"login_login__1o52u","entranceOptions":"login_entranceOptions__emz6t"};